import React, { useEffect } from "react";

const Italy = () => {
    useEffect(() => {
        window.location.href = "https://www.youtube-nocookie.com/embed/NrUP9FCS0RU?playlist=NrUP9FCS0RU&autoplay=1&iv_load_policy=3&loop=1&start=";
    }, []);

    return null;
};

export default Italy;